// extracted by mini-css-extract-plugin
export default {"box":"index_box_idipo","footer":"index_footer_fdCX7"};